var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"units-list overflow-auto pt-5 scroll px-2"},[_c('lazy-load',{on:{"on-response":function (ref) {
      var items = ref.items;

      return _vm.courseUnits.push.apply(_vm.courseUnits, items);
}},model:{value:(_vm.loadMore),callback:function ($$v) {_vm.loadMore=$$v},expression:"loadMore"}},_vm._l((_vm.courseUnits),function(unit,idx){return _c('unit-card',{key:("" + (unit.id) + idx),staticClass:"mb-10",attrs:{"unit":unit,"to":{
        name: 'EducationLessonList',
        params: { courseId: _vm.course.id, unitId: unit.id },
      }}})}),1),_c('v-fade-transition',[(_vm.loading)?_c('v-skeleton-loader',{staticClass:"fill-width",attrs:{"type":"list-item-two-line@5"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }